<template>
      <div class="staffRequirementSubmissionEdit">
        <v-breadcrumbs>
          <v-breadcrumbs-item :exact="true" :to="{ name: 'home', params: {} }"
            >Home</v-breadcrumbs-item
          >
          <v-breadcrumbs-divider>/</v-breadcrumbs-divider>
          <v-breadcrumbs-item :exact="true" :to="{ name: 'staffRequirementSubmission', params: {} }">
          Staff Requirement Submission
          </v-breadcrumbs-item>
          <v-breadcrumbs-divider>/</v-breadcrumbs-divider>
          <v-breadcrumbs-item :to="{ name: 'staffRequirementSubmissionEdit', params:{id: id} }">
            Edit Staff Requirement Submission
          </v-breadcrumbs-item>
        </v-breadcrumbs>

        <v-card>
          <v-card-title>Edit Staff Requirement Submission</v-card-title>
          <v-card-text>
            <staffRequirementSubmission-form :id="id"></staffRequirementSubmission-form>
          </v-card-text>
        </v-card>
      </div>
    </template>

    <script>
    import StaffRequirementSubmissionForm from './StaffRequirementSubmissionForm.vue';

    export default {
      name: 'staffRequirementSubmission',
      data () {
        return {
          id: null
        }
      },
      components: {
        StaffRequirementSubmissionForm
      },
      created () {
          this.id = this.$route.params.id;
          this.$emit("showParent", false);
      }
    }
    </script>
    